<template>
    <v-file-input
        v-model="files"
        chips
        counter
        prepend-icon="mdi-paperclip"
        outlined
        :append-icon="fileUrl &&  !uploadingFile ? 'mdi-download': ''"
        :clearable="!uploadingFile"
        :loading="uploadingFile"
        :accept ="getExtensionsAccepted()"
        :show-size="1000"
        :label="label"
        :placeholder="field.ayuda"
        :class="field.extra.attributes"
        :readonly="readonly"
        :rules="rules"
        :error-messages="errorMessage"
        :success-messages="successMessage"
        :messages="uploadingMessage"
        @change="onUploadFile"
        @click:append="downloadFile"
        :name="`process[${field.nombre}]`"
    >
        <template v-slot:selection="{}">
            <v-chip
                :color="uploadingFile ? 'secondary': 'primary'"
                dark
                label
            >
                {{ field.nombre +'.'+fileName.split('.')[1] }}
            </v-chip>
        </template>
    </v-file-input>
</template>

<script>
import axios from 'axios'
import procedureFormValidator from "bestgob-core/form/procedure.form.validator";
import * as Storage from 'bestgob-core/core/storage.js'

export default {
    name: "File",
    props: ['field', 'readonly', 'label', 'formValues', 'dynamicTable', 'row'],

    data() {
        return {
            rules: [procedureFormValidator.file.required(this.field.validacion.required, this.readonly)],
            uploadingFile: false,
            files: null,

            fileName: '',
            fileUrl: null,
            mimeType: '',
            fileResultData: {},
            errorMessage: null,
            successMessage: null,
            uploadingMessage: null,
        }
    },

    mounted() {
        if (this.formValues[this.field.nombre] != null){
            if (this.dynamicTable){
                this.fileName = this.formValues[this.field.nombre].file_name
                this.fileUrl = this.formValues[this.field.nombre].url
            }else{
                this.fileUrl = this.formValues[this.field.nombre]
                this.fileName = this.field.fileName
            }

            if (this.fileName != ''){
                this.files = new File(["foo"], this.formValues[this.field.nombre].fileName)
            }
        }
    },

    methods: {
        onUploadFile(file){
            this.errorMessage = null

            if (file){
                let extensionArray = file.name.split('.')
                if (extensionArray.length > 1){
                    let extension = extensionArray[extensionArray.length -1]
                    let acceptExtensions = this.getExtensionsAccepted().split(',')

                    if (acceptExtensions.includes('.'+extension)){
                        this.uploadingFile = true

                        this.fileName = file.name
                        this.mimeType = file.type

                        this.readFile(file)

                        return;
                    }
                }

                this.errorMessage = "El archivo seleccionado no es válido solo se aceptan: "+this.getExtensionsAccepted()
                setTimeout(() => {
                    this.errorMessage = null
                }, 5000)

            }else {
                this.formValues[this.field.nombre] = null
                this.fileName = null
                this.fileUrl = null
            }
        },

        getExtensionsAccepted(){
            let accepted = ""
            this.field.extra.filetypes.forEach((extension) => {
                accepted += `.${extension},`
            })

            let finalAccepted =  accepted.slice(0, -1)
            console.log(finalAccepted)

            return finalAccepted
        },
        readFile(file){
            let reader = new FileReader()
            reader.readAsArrayBuffer(file)

            reader.onload =  evt => {
                this.uploadFile(evt.target.result)
            }
        },

        uploadFile(data) {
            this.uploadingMessage = "Procesando el archivo, espere un momento."

            let token = Storage.getItem('token')
            axios.post(`${this.field.extra.upload_url}/${this.getRow()}?${this.field.extra.field_name}=${this.fileName}`,
                data,
                {
                    headers: {
                        "Content-Type": this.mimeType,
                        'Authorization': `Bearer ${token}`
                    }
                })
                .then((result) => {
                    this.fileName = result.data.value
                    this.fileUrl = result.data.public_url

                    if (this.dynamicTable){
                        this.formValues[this.field.nombre] = {
                            file_name: result.data.value, url: result.data.public_url
                        }
                    }else{
                        this.formValues[this.field.nombre] = result.data.value
                    }

                    this.uploadingFile = false
                    this.uploadingMessage = null

                    this.successMessage = "El archivo fue procesado y subido correctamente."
                    setTimeout(() => {
                        this.successMessage = null
                    }, 5000)
                })
                .catch((error) => {
                    this.formValues[this.field.nombre] = null
                    this.fileName = null
                    this.fileUrl = null

                    this.uploadingMessage = null
                    this.errorMessage = "Hubo un error al intentar subir el archivo. " + error.message
                    setTimeout(() => {
                        this.errorMessage = null
                    }, 5000)
                })
        },

        downloadFile(){
            window.open(this.fileUrl)
        },

        getRow(){
            return this.row != undefined ? this.row : ''
        }
    }
}
</script>

<style >
    .v-text-field--enclosed .v-input__prepend-outer{
        /* margin-top: 1rem !important; */
        display: none;
    }
</style>